//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LineChart from '@/assets/img/motifs/line-chart.svg';
import WhiteLogo from '@/assets/img/primary-logo-white.svg';

export default {
  name: 'UserSidebar',
  data() {
    return {
      logo: WhiteLogo,
      motif: LineChart,
    };
  },
  computed: {
    logoVersion() {
      return this.logo;
    },
    loginTip() {
      const possibleTips = this.$t('userSidebar.loginLines');
      return possibleTips[Math.floor(Math.random() * possibleTips.length)];
    },
    routeName() {
      return this.$route.name;
    },
    routeQuery() {
      return this.$route.query;
    },
  },
};
